// extracted by mini-css-extract-plugin
export default {"root":"FileListGalleryItem_root__3JsFe","thumbnail":"FileListGalleryItem_thumbnail__3GHOf","itemText":"FileListGalleryItem_itemText__1R4g7"};